import { CarouselProvider } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import React, { FC } from 'react';
import { ReactComponent as IconChevron } from '../../assets/icons/icon-chevron.svg';
import {
  BackButton,
  DialogNavWrapper,
  IconWrapper,
  LeftFacingChevron,
  NavDots,
  NextButton,
} from './carousel.styles';

interface Props {
  numberOfSlides: number;
}

const Carousel: FC<Props> = ({ numberOfSlides, children }) => {
  return (
    <CarouselProvider
      naturalSlideWidth={500}
      naturalSlideHeight={500}
      totalSlides={numberOfSlides}
    >
      {children}
      <DialogNavWrapper>
        <BackButton>
          <IconWrapper>
            <LeftFacingChevron />
          </IconWrapper>
        </BackButton>
        <NavDots />
        <NextButton>
          <IconWrapper>
            <IconChevron />
          </IconWrapper>
        </NextButton>
      </DialogNavWrapper>
    </CarouselProvider>
  );
};

export default Carousel;
